import React from 'react';
import ReactDOM from 'react-dom';
import DeleteCommonModal from '../../deleteCommonModal.component';
import EditMetric from './editMetric.component';
import GoalServices from '../../../services/goal.services';
import { reactLoader, removeReactLoader, WbEventHandlerMixins } from '../../../utils/common.js';
import { withTranslation } from 'react-i18next';
class EditSingleMetric extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      goalDetails: {},
      showRealOwner: null,
      item: {},
      callEditMetric: false,
      deleteKrList: false,
      showCommittedTarget: null,
      integrations: null,
      userData: {}
    };

    this.closeKrRightPane = this.closeKrRightPane.bind(this);
    this.krDelete = this.krDelete.bind(this);
    this.exitDeleteModal = this.exitDeleteModal.bind(this);
    this.deleteKrList = this.deleteKrList.bind(this);
    this.GoalServices = new GoalServices();
    this.scrollH = 0;
    this.contentTd2 = document.querySelector('.contentTd2');
    this.htmlEl = document.querySelector('html');
    this.htmlElOverflowY = this.htmlEl.style.overflowY
    this.updateKRDataObject = this.updateKRDataObject.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
  }

  componentDidMount() {
    const { goalId, metId, goalDetails, ...resp } = this.props;
    if (Array.isArray(goalDetails.metrics) && goalDetails.metrics.length) {
      goalDetails.metrics = goalDetails.metrics.map((m) => {
        if (m.description) {
          m.description = m.description.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
        }
        return m;
      })
    }
    const itemVal = goalDetails.metrics.find((item) => {
      if (item.id === metId) {
        return item;
      } else {
        item.nested_krs.find(nItem => nItem.id == metId)
      }
    });
    this.setState({
      goalDetails,
      showRealOwner: resp.show_real_owner,
      item: itemVal,
      callEditMetric: true,
      isZenryDomain: resp.isZenryDomain,
      kr_ui_wizard: resp.kr_ui_wizard,
      ext_app_iframe_source: resp.ext_app_iframe_source,
      kr_relationship: resp.kr_relationship,
      display_kr_clustering: resp.display_kr_clustering,
      display_nested_kr: resp.display_nested_kr,
      showCommittedTarget: resp.showCommittedTarget,
      integrations: resp.integrations,
      isEnabledBiweeklyKR: resp.isEnabledBiweeklyKR,
      userData: resp.userData,
      isOwnerOfCascade: (itemVal && itemVal.isOwnerOfCascade !== undefined) ? itemVal.isOwnerOfCascade : false
    }, () => {
      if (this.contentTd2) {
        this.contentTd2.style.top = `-${window.scrollY-85}px`;
        this.contentTd2.style.position = 'fixed';
        this.htmlEl.style.overflowY = 'hidden';
      }
    });
  }

  componentWillUnmount(){
    const scrollY = this.contentTd2.style.top;
    this.contentTd2.style.position = '';
    this.contentTd2.style.top = '';
    window.scrollTo(0, (parseInt(scrollY)-85) * -1);
    this.htmlEl.style.overflowY = this.htmlElOverflowY;
  }

  deleteKrList() {
    this.setState({ deleteKrList: true });
  }

  krDelete(id) {
    if (id != '' && id != undefined) {
      reactLoader(true);
      this.GoalServices.deleteMetric({ metricId: id }).then((response) => {
        removeReactLoader();
        this.closeKrRightPane(true,true);
        if(this.props.editFrom == "kr-page"){
          this.props.reloadComp("delete");
        }
        this.handleFocus()
      });
    }
  }

  handleFocus() {
    if (this.props.goalId !== "" || goalId !== undefined) {
      setTimeout(() => {
        const targetObjective = document.getElementById(`okr-goal-section_button_${this.props.goalId}`)
        targetObjective.focus()
      }, 100)
    }
  }

  closeKrRightPane(cancel,deleteKr=false) {

    const onClosed = this.props.onClosed;
    if (document.getElementById('mySidenasSingleEdit')) {
      ReactDOM.unmountComponentAtNode(document.getElementById('mySidenasSingleEdit'));
    }
    if (onClosed) onClosed();
    if(!cancel) {
      return overflowHiddenFunction(false);
    }
    var e = document.querySelector('body');
    if (e) {
      e.style.overflow = 'visible';
    }
    if(this.props.editFrom == "kr-page"){
      if (cancel) {
        this.props.reloadComp(this.props.editFrom);
      }
    }else{
      let actionType= 'edit'
      if(deleteKr){
        actionType = 'deletekr'
      }
      if(typeof window.MyGoalContainer !== 'undefined'){ // some pages have no MyGoalContainer (e.g. HeatMap)
        window.MyGoalContainer.updateGoalItems({ action: actionType, goalId: this.props.goalId,metricId: this.props.metId });
      }
      if(window.refreshExpandedGoal){
        window.refreshExpandedGoal();
      }
    }
    return overflowHiddenFunction(false);
  }

  exitDeleteModal() {
    this.setState({ deleteKrList: false });
  }

  updateKRDataObject(value, krData)
  {
    this.setState({
      item: {
        ...this.state.item,
        name: value
      }
    })
  }

  render() {
    const { 
      goalDetails,
      isZenryDomain,
      kr_ui_wizard,
      ext_app_iframe_source,
      kr_relationship,
      display_kr_clustering,
      display_nested_kr,
      showCommittedTarget,
      integrations,
      isEnabledBiweeklyKR = false,
      item,
      showRealOwner,
      deleteKrList,
      callEditMetric
    } = this.state;
    const krType = WbEventHandlerMixins.getKrType(item.source, item.type, item.ext_app_id);
    const basicInlineData = [];
    const addOkrData = {
      goalDetails,
      category_exist: 1,
      myGoal: goalDetails.type,
      isZenryDomain,
      kr_ui_wizard,
      ext_app_iframe_source,
      kr_relationship,
      display_kr_clustering,
      display_nested_kr,
      showCommittedTarget,
      integrations,
      isEnabledBiweeklyKR
    };
    const { t, metId, isChildKr } = this.props;
    return (
      <div>
        {
          callEditMetric
          && (
          <EditMetric
            addOkrData={addOkrData}
            goalDetails={goalDetails}
            goalType={item.type}
            krType={krType}
            closeKrRightPane={this.closeKrRightPane}
            item={item}
            krDelete={this.deleteKrList}
            addKrValue=""
            basicInlineData={basicInlineData}
            MetricChangeWeight={this.MetricChangeWeight}
            onlyMetEdit
            cancelKrInfo={this.closeKrRightPane}
            isChildKr={isChildKr}
            showRealOwner={showRealOwner}
            integrations={integrations}
            updateSingleItem={(metric) => this.setState({ item: metric})}
            updateKRDataObject={this.updateKRDataObject}
            groupKRCustomFields={this.props.groupKRCustomFields}
            isOwnerOfCascade={this.state.isOwnerOfCascade}
          />
          )
        }
        {
        deleteKrList
          && (
          <DeleteCommonModal
            exitDeleteModal={this.exitDeleteModal}
            deleteItems={this.krDelete}
            title={t("Exit without saving")}
            deleteContentOne={t("Are you sure you want to")}
            deleteContentSecond={`${t('leave without saving your key result')}?`}
            buttonText={t("Exit")}
            deleteContentSecondParam={`${t('delete key result?')}`}
            deletefirstTitle={`${t('Delete')} ${isChildKr ? t('Supporting'): ''} ${t('Key Result')}`}
            deleteContentBodyText={`${t('Are you sure you want to delete this')} ${isChildKr ? t('supporting'): ''} ${t('key result? This cannot be undone.')}`}
            id={metId}
          />
          )
        }
      </div>
    );
  }
}

export default withTranslation()(EditSingleMetric);
